<template>
  <b-modal
    cancel-title="cancel"
    cancel-variant="light"
    :ok-title-html="modalsubmit==true?loaderIcon+'Save':'Save'"
    :ok-disabled="modalsubmit"
    :no-close-on-backdrop="true"
    id="productserialnosdetails"
    size="lg"
    v-model="serialnomodalshow"
    @shown="checkforanentity"
    body-class="bg-white"
    title="Select Serial Number(s)"
    ref="productserialnosdetails"
    @ok.prevent="handleSubmit"
  >
    <b-row>
      <b-col xl="12" lg="12" md="12" xs="12" sm="12">
        <div class="container-fluid">
          <b-alert class="alert-transparent alert-danger" :show="error_true">
            <p class="fw-semi-bold">{{ message }}</p>
          </b-alert>
        </div>
      </b-col>
    </b-row>
    <div
      class="customer_view_tab sn-input-form no-flex-grow"
      pills
      small
      v-if="singleitemserialnorow.serialnodetails && showdatas"
    >
      <div class="txn-creation primary-info sn-creation">
        <div class="row">
          <div class="col-lg-5">
            <label class="font-medium">{{singleitemserialnorow.pdt_detail_id}}</label>
            <div class="font-small text-draft">UNIT: {{singleitemserialnorow.unit_name}}</div>
          </div>
          <div class="col-lg-3 offset-lg-4 text-center">
            <div
              class="font-large"
            >{{$route.meta.page == "inventoryadjustments" ? Math.abs(singleitemserialnorow.pdt_adjsmnt_qty) : singleitemserialnorow.pdt_qty}}</div>
            <div class="font-small text-draft">Quantity</div>
          </div>
        </div>
      </div>
      <div class="clearfix">
        <label>
          <span class="text-draft">count:</span>
          <span>{{serial_nos.length}}</span>
        </label>
      </div>

      <template
        v-if="$route.meta.page == 'invoice' || ($route.meta.page == 'inventoryadjustments' && parseFloat(singleitemserialnorow.pdt_adjsmnt_qty) < 0) || $route.meta.page == 'vendorcredit' || $route.meta.page == 'transferorder'"
      >
        <v-select
          :clearable="false"
          multiple
          push-tags
          size="sm"
          index="label"
          :options="singleitemserialnorow.serialnodetails[singleitemserialnorow.warehouse_id]"
          label="label"
          id="serial-no-select"
          v-model.trim="serial_nos"
          placeholder="Choose serial nos"
          name="serial_nos"
        >
          <template
            slot="option"
            slot-scope="option"
            v-if="option.type == 1 || serial_nos.includes(option.value)"
          >{{ option.label }}</template>
        </v-select>

        <label class="pt-5 text-draft">
          <div>Note:</div>
          <ul>
            <li>1. Serial numbers used in other transactions will not be displayed here, irrespective of the transaction status.</li>
            <!-- <li>2.You can enable Barcode Scanning to scan the serial numbers in .</li> -->
          </ul>
        </label>
      </template>

      <template
        v-if="$route.meta.page == 'credit'  ||  $route.meta.page == 'bill' || ($route.meta.page == 'inventoryadjustments' && parseFloat(singleitemserialnorow.pdt_adjsmnt_qty) > 0)"
      >
        <v-select
          :clearable="false"
          multiple
          :taggable="$route.meta.page == 'credit' || $route.meta.page == 'bill' || $route.meta.page == 'inventoryadjustments'"
          push-tags
          size="sm"
          :options="$route.meta.page == 'inventoryadjustments' ? [] : singleitemserialnorow.serialnodetails[singleitemserialnorow.warehouse_id]"
          id="serial-no-select"
          v-model.trim="serial_nos"
          placeholder="Choose serial nos"
          name="serial_nos"
        ></v-select>
      </template>
    </div>
  </b-modal>
</template>

<script>
import vSelect from "vue-select"; // vue seatch select component
export default {
  props: ["singleitemserialnorow"],
  components: {
    vSelect
  },
  data() {
    return {
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      serial_nos: [],
      message: "",
      serialnomodalshow: false,
      error_true: false,
      modalsubmit: false,
      showdatas: false
    };
  },
  methods: {
    async checkforanentity() {
      this.serial_nos = JSON.parse(
        JSON.stringify(this.singleitemserialnorow.pdt_serial_nos)
      );

      if (this.$route.meta.page == "credit") {
        this.singleitemserialnorow.serialnodetails[
          this.singleitemserialnorow.warehouse_id
        ] = JSON.parse(
          JSON.stringify(this.singleitemserialnorow.pdt_serial_nos)
        );
      } else if (this.$route.meta.page == "bill") {
        this.singleitemserialnorow.serialnodetails[
          this.singleitemserialnorow.warehouse_id
        ] = [];
      }
      this.message = "";
      this.error_true = false;
      this.modalsubmit = false;
      this.showdatas = true;
    },
    handleSubmit() {
      if (
        this.$route.meta.page != "inventoryadjustments" &&
        this.serial_nos.length != this.singleitemserialnorow.pdt_qty
      ) {
        this.message =
          "Looks like there's a mismatch between the quantity and the serial numbers entered.";
        this.error_true = true;
        this.modalsubmit = false;
        return;
      }
      if (
        this.$route.meta.page == "inventoryadjustments" &&
        this.serial_nos.length !=
          Math.abs(this.singleitemserialnorow.pdt_adjsmnt_qty)
      ) {
        this.message =
          "Looks like there's a mismatch between the adjusted quantity and the serial numbers selected.";
        this.error_true = true;
        this.modalsubmit = false;
        return;
      }
      this.modalsubmit = true;
      this.error_true = false;
      this.singleitemserialnorow.pdt_serial_nos = JSON.parse(
        JSON.stringify(this.serial_nos)
      );
      this.serialnomodalshow = false;
      this.showdatas = false;
    }
  }
};
</script>

<style>
.sn-input-form .sn-creation {
  margin-bottom: 5px;
  padding: 20px 10px 20px 6px;
  background-color: #fbfbfb;
}
</style>
